/**
 * Mensagens de erro padronizadas para o sistema de contexto
 */

export const CONTEXT_ERRORS = {
  NO_NETWORK: 'Selecione uma Rede para continuar.',
  NO_STORE: 'Selecione uma Loja para acessar este módulo.',
  NO_SCOPE: 'Você não possui escopo para esta loja.',
  NO_FEATURE: 'Este módulo não faz parte das suas áreas de acesso.',
  CONTEXT_EXPIRED: 'Seu contexto expirou. Atualizamos para \'Modo Rede\'.',
  INVALID_NETWORK: 'A rede selecionada não é mais válida ou foi desativada.',
  INVALID_STORE: 'A loja selecionada não é mais válida ou foi desativada.',
  NETWORK_REQUIRED: 'É necessário selecionar uma rede para continuar.',
  STORE_REQUIRED: 'É necessário selecionar uma loja para acessar esta funcionalidade.',
  PERMISSION_DENIED: 'Você não tem permissão para realizar esta ação.',
  SCOPE_VIOLATION: 'Esta loja não está no seu escopo de acesso.',
  NETWORK_INACTIVE: 'Esta rede foi desativada pelo administrador. Entre em contato com o suporte para mais informações.',
} as const;

export type ContextErrorKey = keyof typeof CONTEXT_ERRORS;
